import React, { useState } from "react";

//styles
import styled from "styled-components";
import SV from "../../styles/variables";

//components
import CustomSelect from "../../components/select";
import {
  H2,
  Container,
  HeaderRow,
  Overflow
} from "../../components/layout/box";

//models
import { TooltipObj } from "../../models/tooltip";
import Tooltip from "../../components/tooltip";

//data-vis
import {
  XYPlot,
  XAxis,
  YAxis,
  VerticalBarSeries,
  VerticalBarSeriesPoint,
  ChartLabel
} from "react-vis";

//helpers
import {
  getRelativePosition,
  getOptions,
  getSelectedBrands,
  MockDataStores
} from "./helpers";
import { SizeMe } from "react-sizeme";

const width = 656;
const padding = 40;
const height = 416;
const minSize = 480;

const ViewsByStore = () => {
  const [options, setStateOptions] = useState(getOptions(MockDataStores));
  const [tooltip, setStateToolTip] = useState<TooltipObj>({
    open: false,
    x: 0,
    y: 0
  });

  const SelectedData = getSelectedBrands(options, MockDataStores);
  const GridRef = React.useRef<any>();

  return (
    <SizeMe monitorWidth={true}>
      {({ size }) => {
        if (size && size.width)
          return (
            <Overflow minSize={minSize}>
              <Container width={size.width} padding={padding}>
                <HeaderRow>
                  <H2> Stores and number of views </H2>
                  <div style={{ display: "inline-block", height: "25px" }}>
                    <CustomSelect
                      options={options}
                      title="All Stores"
                      setState={setStateOptions}
                      limit={6}
                      dropdownTitle="Select max 6 stores"
                    />
                  </div>
                </HeaderRow>
                <div ref={GridRef}>
                  <XYPlot
                    width={Math.max(size.width, minSize) - padding * 2}
                    height={size.width * 0.66}
                    xType="ordinal"
                    margin={{ left: 70 }}
                  >
                    <YAxis />
                    <ChartLabel
                      text="Number of views"
                      xPercent={0.02}
                      yPercent={0.4}
                      className="YAxis"
                      style={{
                        transform: "rotate(-90)",
                        textAnchor: "start",
                        height: "20px",
                        font: "25px"
                      }}
                    />
                    <VerticalBarSeries
                      data={SelectedData}
                      barWidth={SelectedData[0].x ? 0.5 : 0}
                      color="rgba(0, 0, 255)"
                      opacity={0.2}
                      onValueMouseOver={(datapoint, event: any) => {
                        if (GridRef && GridRef.current) {
                          const { x, y } = getRelativePosition(
                            event.event.target,
                            GridRef.current as HTMLElement,
                            "bar"
                          );
                          setStateToolTip({
                            x,
                            y,
                            open: true,
                            views: datapoint.y
                          });
                        }
                      }}
                      onValueMouseOut={() => {
                        setStateToolTip({
                          open: false
                        });
                      }}
                    />
                    <XAxis />
                    <Tooltip
                      open={tooltip.open}
                      x={tooltip.x}
                      y={tooltip.y}
                      views={tooltip.views}
                    />
                  </XYPlot>
                </div>
              </Container>
            </Overflow>
          );
        else return <div />;
      }}
    </SizeMe>
  );
};

export default ViewsByStore;
